
import { useQuery } from '@tanstack/react-query';
import { fetchGroupUsers, GROUP_USERS_QUERY_KEY, type GroupUser } from '@client/features/users';
import type { AgentOption } from './StepAccess.tsx';

function toAgentOption(u: GroupUser): AgentOption {
  return { id: u.id, name: u.name, email: u.email, roles: u.roles };
}

function isPickable(u: GroupUser): boolean {
  return u.isActive && !u.pending;
}

export interface GroupAgentsState {
  agents: AgentOption[];
  loading: boolean;
  error: boolean;
}

export function useGroupAgents(): GroupAgentsState {
  const query = useQuery({
    queryKey: GROUP_USERS_QUERY_KEY,
    queryFn: ({ signal }) => fetchGroupUsers(signal),
  });

  const agents = (query.data ?? [])
    .filter(isPickable)
    .map(toAgentOption)
    .sort((a, b) => a.name.localeCompare(b.name));

  return { agents, loading: query.isLoading, error: query.isError };
}
